<template lang="jade">
  div.Paginator
    a.Paginator__prev(":disabled"="page <= 1"
                      @click="page--")
      i.fa.fa-angle-left
    input.Paginator__input(type="text"
                           v-model="page")
    a.Paginator__next(":disabled"="page >= pages"
                      @click.prevent="page++")
      i.fa.fa-angle-right
    span(class="Paginator__meta") of {{ Math.ceil(records / limit) }} pages
</template>

<script>
export default {
  data: () => ({}),
  props: {
    page: {
      type: Number,
      coerce: x => parseInt(x),
      required: true
    },
    records: {
      type: Number,
      coerce: x => parseInt(x),
      required: true
    },
    limit: {
      type: Number,
      coerce: x => parseInt(x),
      required: true
    }
  },
  computed: {
    pages: () => Math.ceil(this.records / this.limit)
  }
}
</script>



// WEBPACK FOOTER //
// paginator.vue?694e95de